import Joi from 'joi';
import { AxiosError } from 'axios';
import api from '../api';

/**
 * Get customers List
 * @param {object} queryParams - The query parameters.
 * @returns {Promise<
 * {total: number, pageNumber: number, data: Customer[]}>} - The list of customers.
 */
export const getCustomers = async (queryParams) => {
  // remove empty queryParams
  const cleanQueryParams = queryParams;
  Object.keys(cleanQueryParams).forEach(
    /**
     * @param {keyof typeof queryParams} key
     * @returns {void} - remove empty queryParams
     */
    (key) => {
      if (!cleanQueryParams[key]) {
        delete cleanQueryParams[key];
      }
    },
  );
  const result = await api.get('/customers', { params: cleanQueryParams });

  try {
    const schema = Joi.object({
      total: Joi.number().required(),
      // pageNumber: Joi.number().required(),
      data: Joi.array().items(
        Joi.object({
          id: Joi.number().required(),
          firstname: Joi.string().required(),
          lastname: Joi.string().required(),
          email: Joi.string().required(),
          phone: Joi.string().required(),
          status: Joi.string().default('pending').required(),
          company: Joi.string().allow(null, ''),
        }),
      ),
    }).required();
    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (/** @type {any} */ error) {
    throw new AxiosError('', `API response do not match Customer list Schema : ${error.message}`);
  }

  return result.data;
};

/**
 * Update a customer
 * @param {Customer} params - The query parameters.
 * @returns {Promise<Customer>} - The newly created customer.
 */
export const updateCustomer = async (params) => {
  const result = await api.put(`/customers/${params.id}`, params);

  try {
    const schema = Joi.object({
      id: Joi.number().required(),
      firstname: Joi.string().required(),
      lastname: Joi.string().required(),
      email: Joi.string().required(),
      phone: Joi.string().required(),
      status: Joi.string().valid('pending', 'validate').required(),
      company: Joi.string().allow(null, ''),
    }).required();

    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (/** @type {any} */ error) {
    throw new AxiosError('', `API response do not match Customer list Schema : ${error.message}`);
  }

  return result.data;
};

/**
 * Create a new customer
 * @param {Customer} customer
 * @returns {Promise<any>} - 201 return code
 */
export const createCustomer = async (customer) => {
  const result = await api.post('/customers', customer);
  return result.status;
};

/**
 * Delete a customer
 * @param {number} id - The customer id to delete
 * @returns {Promise<number>} - 204 return code
 */
export const deleteCustomer = async (id) => {
  const result = await api.delete(`/customers/${id}`);
  return result.status;
};
